import Vue from "vue";
import Router from "vue-router";
// 更新引入路径
import IndexPage from "@/views/index/index.vue";
import commodityView from "@/views/index/commodityView.vue";
import guanyuWomen from "@/views/index/guanyuWomen.vue";
import loginPage from "@/views/login/login.vue";
import findPage from "@/views/login/find.vue";
import registerPage from "@/views/login/register.vue";
import userPage from "@/views/login/userPage.vue";

Vue.use(Router);

const router = new Router({
	routes: [{
			path: "/",
			name: "index",
			component: IndexPage,
		},
		{
			path: "/detail",
			name: "detail",
			component: commodityView,
		},
		{
			path: "/login",
			name: "login",
			component: loginPage,
		},
		{
			path: "/find",
			name: "find",
			component: findPage,
		},
		{
			path: "/register",
			name: "register",
			component: registerPage,
		},
		{
			path: "/my",
			name: "my",
			component: userPage,
		},
		{
			path: "/about",
			name: "about",
			component: guanyuWomen,
		},
	],
});

// router.beforeEach((to,from,next)=>{
// 	console.log('to',to)
// 	console.log('from',from)
// 	if(to.path == '/my'){
// 		let token = localStorage.getItem('App-Token') || ''
// 		console.log('token',token)
// 		if(token == ''){
// 			next('/login')
// 		}else{
// 			next()
// 		}
// 	}else if(to.path == '/login'){
// 		console.log('to ...')
// 		return
// 	} else{
// 		next()
// 	}
// })
export default  router